import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router';
import { getSystemQuery } from '~/shared/api/system.queries';
import { checkAuthorization } from '~/shared/auth/auth-utils';
import { assertIsDefined } from '~/types/assert-type';

export const downloadsLoader =
  (queryClient: QueryClient) =>
  async ({ request, params }: LoaderFunctionArgs) => {
    await checkAuthorization(queryClient, request);

    const { systemId } = params;

    assertIsDefined(systemId);

    const system = await queryClient.ensureQueryData(getSystemQuery(systemId));

    return { system };
  };
